import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import io from 'socket.io-client';
import config from 'config';
import { injectIntl } from 'react-intl';
import * as marketActions from 'store/modules/market';
import * as walletActions from 'store/modules/wallet';
import * as socketActions from 'store/modules/socket';
import { toast } from 'react-toastify';
import _reverse from 'lodash/reverse'
import API from 'services';

let prevChannel = null;
let socket = null;
const SocketController = injectIntl(({ intl, ...props }) => {
  const uri =
    'https://node-sock.unionex.market:3999/channel?apikey=&ssid=&market=usdt';
  const nowChannelt = useSelector(state => state.socket);
  const nowChannel = useSelector(state => state.socket.nowChannel);
  const tradeRegistered = useSelector(state => state.socket.tradeRegistered);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const language = useSelector(state => state.app.language);
  const memberInfo = useSelector(state => state.auth.memberinfo);

  const [prevSessionKey, setPrevSessionKey] = useState(null);

  const dispatch = useDispatch();
  const setTicker = master => dispatch(marketActions.setTicker(master));
  const setTradeRegistered = v => dispatch(socketActions.setTradeRegistered(v));
  const setOrderbook = v => dispatch(marketActions.setOrderbook(v));
  const setTradeHistory = v => dispatch(marketActions.setTradeHistory(v));
  const setTotalVolume = v => dispatch(marketActions.setTotalVolume(v));
  const setMyAssets = v => dispatch(walletActions.setMyAssets(v));
  const setReload = () => dispatch(marketActions.setReload());
  // first connect socket
  if (!socket) socket = io.connect(uri);

  const setSocketListener = () => {
    socket.on('connect', function () {
      socket.emit('join', nowChannel, function (e) { });
    });

    // socket 이벤트 리스너 달아주기
    socket.on('ticker', function (ticker) {
      setTicker(ticker);
    });

    socket.on('orderbook', function (sellOrderbook, buyOrderbook, market) {
      if (typeof buyOrderbook === 'undefined' || buyOrderbook === null)
        buyOrderbook = [];
      if (typeof sellOrderbook === 'undefined' || sellOrderbook === null)
        sellOrderbook = [];
      //if(nowChannel === market || nowChannel === 'ticker'){
      setOrderbook({
        buy: buyOrderbook.slice(0, config.ORDERBOOK_VIEW_COUNT),
        sell: _reverse(_reverse(sellOrderbook).slice(0, config.ORDERBOOK_VIEW_COUNT))
      });
      //}
    });

    socket.on('order_history', function (tradeHistory, market) {
      if (nowChannel === market || nowChannel === 'ticker') {
        setTradeHistory(tradeHistory !== null ? tradeHistory : []);
      }
    });

    socket.on('total_volume', function (totalVolume) {
      setTotalVolume(totalVolume);
    });

    socket.on('mybalance', function (res) {
      API.accounts()
        .getMyBalance()
        .then(res => {
          setMyAssets(res.data.data.balance);
        });
    });

    socket.on('mynotice', res => {
      const msgData = JSON.parse(res);
      // 로그인때에만 토스트 표시
      if (isAuthenticated) {
        toast[msgData.status == 'success' ? 'success' : 'error'](
          intl.formatMessage({ id: `socket_api_code.${msgData.Code}` }, msgData)
        );
      }
    });

    socket.on('mytradecomplete', function (res) {
      socket.emit('trade', 'tradecomplete', function (e) { });
      setReload();
    });
  };

  const refreshSocketListener = () => {
    socket.removeAllListeners();
    setSocketListener();
  };

  useEffect(() => {
    setSocketListener();
  }, []);

  useEffect(() => {
    refreshSocketListener();
  }, [language, nowChannel]);

  useEffect(() => {
    if (tradeRegistered) {
      socket.emit('trade', 'orderbook', function (e) { });
      setTradeRegistered(false);
    }
  }, [tradeRegistered]);

  useEffect(() => {
    if (isAuthenticated) {
      setPrevSessionKey(memberInfo.socket_session_key)
      socket.emit('login', memberInfo ? memberInfo.socket_session_key : '', function (e) { });
    } else if (prevSessionKey) {
      socket.emit('logout', prevSessionKey, function (e) { });
      setPrevSessionKey(null);
    }
  }, [isAuthenticated, memberInfo]);

  // change channel
  if (socket) {
    if (prevChannel && prevChannel !== nowChannel && prevChannel !== 'ticker')
      socket.emit('leave', prevChannel, function (e) { });
    if (!prevChannel || prevChannel !== nowChannel)
      socket.emit('join', nowChannel, function (e) { });
    prevChannel = nowChannel;
  }

  return <></>;
});

export default SocketController;
